/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EngagementPostReactionsDto } from '../../models/engagement-post-reactions-dto';

export interface GetEngagementReactedPosts$Params {
}

export function getEngagementReactedPosts(http: HttpClient, rootUrl: string, params?: GetEngagementReactedPosts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EngagementPostReactionsDto>>> {
  const rb = new RequestBuilder(rootUrl, getEngagementReactedPosts.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EngagementPostReactionsDto>>;
    })
  );
}

getEngagementReactedPosts.PATH = '/api/activities/engagement/reacted-posts';
